import { createContext, useContext, useState } from "react";
import Lightbox from "../components/Lightbox";

const LightboxContext = createContext();

export function LightboxProvider({ children }) {
    const [lightboxState, setLightboxState] = useState({
        isOpen: false,
        imageSrc: "",
        title: "",
    });

    const showLightbox = (src, title = "") => {
        setLightboxState({ isOpen: true, imageSrc: src, title });
    };

    const closeLightbox = () => {
        setLightboxState({ ...lightboxState, isOpen: false });
    };

    return (
        <LightboxContext.Provider value={showLightbox}>
            {children}
            <Lightbox
                isOpen={lightboxState.isOpen}
                imageSrc={lightboxState.imageSrc}
                title={lightboxState.title}
                onClose={closeLightbox}
            />
        </LightboxContext.Provider>
    );
}

export function useLightbox() {
    return useContext(LightboxContext);
}
